import { Inject, Injectable } from "@angular/core";
import { ICardAction } from "@tylertech/tyler-api-types";
import { PacketDetailDialogComponent, PacketDetailDialogData } from "../components/packetDetail/packetDetailDialog.component";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

@Injectable()
export class PacketDialogsService
{
    constructor(private readonly matDialog: MatDialog) { }

    show(
        packetId: string,
        aggregateId: string,
        packetType: string,
        packetNumber: string,
        cardActions: ICardAction[],
        alternateType?: string
    ): Promise<ICardAction>
    {
        const config: MatDialogConfig<PacketDetailDialogData> = {
            data: {
                packetId,
                aggregateId,
                packetType,
                packetNumber,
                cardActions,
                alternateType
            }
        };
        const dialogRef = this.matDialog.open(PacketDetailDialogComponent, config);
        return dialogRef.afterClosed().toPromise();
    }
}
